import styled from 'styled-components'

export const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

export const VideoContainerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

export const VideoContainer = styled.div`
  position: relative;
  height: 100%;
  width: max-content;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
`

export const Video = styled.video`
  display: block;
  height: 100%;
  width: auto;
  max-width: 100%;
  object-fit: contain;
`

export const TV = styled.button`
  position: absolute;
  height: 6%;
  width: 4%;
  z-index: 10;
  background-color: transparent;
  border: none;
`
//`${Math.floor(Math.random() * 5)}%`;
//`${Math.floor(Math.random() * 3)}%`;

export const TVClusterAButton = styled(TV)`
  top: 40%;
  left: 44%;
`

export const TVClusterBButton = styled(TV)`
  top: 40%;
  left: 52%;
  cursor: not-allowed;
`
